import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/autoplay";
export default function Slider(props) {
  const { slides } = props;
  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={50}
      slidesPerView={1}
      loop={true}
      autoplay={{ delay: 3500, disableOnInteraction: false }}
      {...props}
    >
      {slides.map((slide, i) => {
        return (
          <>
            <SwiperSlide>
              <img
                src={slide.url}
                alt={slide.alt ?? `Slide ${i}`}
                key={i}
                loading={i > 0 ? "lazy" : "eager"}
              />
            </SwiperSlide>
          </>
        );
      })}
    </Swiper>
  );
}
